import SliderImageSeparator from "./common/SliderImageSeparator"
import ImageSectionItem from "./common/ImageSectionItem"
import ImageTitleItem from "./common/ImageTitleItem"
import SeparatorLine from "./common/SeparatorLine"
import { Link } from "react-router-dom"
import "./Press.css"
import { useEffect } from "react"

const Press = () => {

    useEffect(() => {
        document.title = 'Séneca - Prensa y comunicación'
        window.scrollTo(0, 0)
    }, [])

    return (

        <main className="press-main">

            <ImageTitleItem
                imageURL="/images/press/prensa-1.jpg"
                titleText="Accede, descarga y publica antes que nadie"
                icon="bi bi-newspaper blue-icon"
                subtitleText="Séneca pone a disposición de los medios el archivo audiovisual completo de las sesiones: busca, descarga y trabaja con el material en el formato que necesites, en directo o bajo demanda."
            />

            <SliderImageSeparator />

            <ImageSectionItem
                imageURL="/images/press/prensa-2.png"
                imagePosition="before"
                layout="row"
                title="Bajo demanda"
                isAnimatedImage="true"
                textArray={[
                    "<p class='middle-section-label'><strong>Los medios pueden buscar por temas, oradores o palabras concretas, filtrando por órgano, fecha o legislatura. Con los resultados, pueden compartirlos, añadirlos a favoritos o guardar los enlaces para uso posterior.</strong></p>",
                    "<p class='middle-section-label'>Los medios autorizados pueden descargar clips de intervenciones o puntos completos del orden del día, seleccionando la calidad adecuada a cada necesidad: Broadcast, Web u otros formatos.</p>"
                ]}
            modern="true"
            />

            <SeparatorLine />

            <ImageSectionItem
                imagePosition="after"
                layout="row"
                imageURL="/images/press/prensa-3.png"
                title="En directo"
                isAnimatedImage="true"
                textArray={[
                    "<p class='middle-section-label'><strong>Séneca permite capturar en directo, en el momento en que ocurre, intervenciones concretas o la secuencia completa de una pregunta en una sesión de control.</strong></p>",
                    "<p class='middle-section-label'>Llega al informativo con el clip antes de que la sesión haya terminado. Los archivos obtenidos son compatibles con los principales editores del mercado: Avid, EDIUS, Premiere y Final Cut.</p>"
                ]}
            modern="true"
            />

            <SeparatorLine />

            <ImageSectionItem
                imagePosition="before"
                layout="row"
                imageURL="/images/press/prensa-4.png"
                title="Todo el material de la sesión"
                isAnimatedImage="true"
                textArray={[
                    "<p class='middle-section-label'><strong>Más allá del vídeo, Séneca centraliza todos los recursos vinculados a cada sesión: archivos de texto, imágenes, notas de prensa y documentación descargable.</strong></p>",
                    "<p class='middle-section-label'>Para la prensa escrita, los filtros de búsqueda por temas, etiquetas o transcripción con búsqueda por palabras permiten localizar cualquier intervención o comparar cómo distintos representantes han tratado un mismo tema. Todo el material está disponible para su publicación.</p>"
                ]}
            modern="true"
            />

            <section className="main-cta-section">
                <h2 className="main-cta-title">¿Quieres probar el acceso?</h2>
                <p className="main-cta-desc">Solicita una demo y descubre cómo Séneca puede mejorar el flujo de trabajo de tu redacción.</p>
                <Link to="/contacto" className="main-cta-button">Solicitar acceso</Link>
            </section>

        </main>

    )
}

export default Press
